import { MLSListing, toPunctuatedPhoneFormat } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSAgentDetails = ({ listingData }: { listingData: MLSListing }) => (
  <>
    <MLSDataInfoSection title="Agent Details">
      <MLSDataColumn>
        <MLSDataValueWithLabel value={listingData.ListAgentFullName} label="Listing Agent" />
        <MLSDataValueWithLabel
          value={
            listingData.ListAgentPreferredPhone
              ? toPunctuatedPhoneFormat(listingData.ListAgentPreferredPhone)
              : ''
          }
          label="Phone"
        />
        <MLSDataValueWithLabel
          value={listingData.ListAgentMlsID ?? listingData.ListAgentKey}
          label="Agent ID"
        />
      </MLSDataColumn>
      <MLSDataColumn>
        <MLSDataValueWithLabel value={listingData.ListOfficeName} label="Listing Office" />
        <MLSDataValueWithLabel
          value={
            listingData.ListOfficePhone ? toPunctuatedPhoneFormat(listingData.ListOfficePhone) : ''
          }
          label="Phone"
        />
        <MLSDataValueWithLabel
          value={listingData.ListOfficeMlsId ?? listingData.ListOfficeKey}
          label="Office ID"
        />
      </MLSDataColumn>
    </MLSDataInfoSection>
    {/* <MlsDataValueWithLabel value={listingData.agents?.listing_agent?.remarks} label="Listing Agent Remarks" /> */}
  </>
);
